// extracted by mini-css-extract-plugin
export default {"root":"style_root__poQVh","avatar":"style_avatar__Ofoxz","input":"style_input__h65Mp"};